import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useConfigStore } from '@/store/config-store'
import { AdminGuard } from '@/components/layout/AdminGuard'

// Builder pages
import Landing from '@/pages/builder/Landing'
import ModelSelect from '@/pages/builder/ModelSelect'
import Customize from '@/pages/builder/Customize'
import Review from '@/pages/builder/Review'
import LeadForm from '@/pages/builder/LeadForm'
import ThankYou from '@/pages/builder/ThankYou'

// Admin pages
import AdminLogin from '@/pages/admin/Login'
import AdminDashboard from '@/pages/admin/Dashboard'
import AdminLeads from '@/pages/admin/Leads'
import AdminLeadDetail from '@/pages/admin/LeadDetail'
import AdminModels from '@/pages/admin/Models'
import AdminCategories from '@/pages/admin/Categories'
import AdminOptions from '@/pages/admin/Options'
import AdminConstraints from '@/pages/admin/Constraints'
import AdminPriceValve from '@/pages/admin/PriceValve'
import AdminSettings from '@/pages/admin/Settings'
import AdminAnalytics from '@/pages/admin/Analytics'
import AdminPipeline from '@/pages/admin/Pipeline'

function ConfigPreloader() {
  const { load } = useConfigStore()
  useEffect(() => { load() }, [load])
  return null
}

export default function App() {
  return (
    <BrowserRouter>
      <ConfigPreloader />
      <Routes>
        {/* ── Public Builder ───────────────────────────────────── */}
        <Route path="/"                element={<Landing />} />
        <Route path="/build"           element={<Navigate to="/build/model" replace />} />
        <Route path="/build/model"     element={<ModelSelect />} />
        <Route path="/build/customize" element={<Customize />} />
        <Route path="/build/review"    element={<Review />} />
        <Route path="/build/submit"    element={<LeadForm />} />
        <Route path="/build/thanks"    element={<ThankYou />} />

        {/* ── Admin login (public) ──────────────────────────────── */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* ── Admin (protected) ────────────────────────────────── */}
        <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="/admin/dashboard"   element={<AdminGuard><AdminDashboard /></AdminGuard>} />
        <Route path="/admin/leads"       element={<AdminGuard><AdminLeads /></AdminGuard>} />
        <Route path="/admin/leads/:id"   element={<AdminGuard><AdminLeadDetail /></AdminGuard>} />
        <Route path="/admin/models"      element={<AdminGuard><AdminModels /></AdminGuard>} />
        <Route path="/admin/categories"  element={<AdminGuard><AdminCategories /></AdminGuard>} />
        <Route path="/admin/options"     element={<AdminGuard><AdminOptions /></AdminGuard>} />
        <Route path="/admin/constraints" element={<AdminGuard><AdminConstraints /></AdminGuard>} />
        <Route path="/admin/price-valve" element={<AdminGuard><AdminPriceValve /></AdminGuard>} />
        <Route path="/admin/settings"    element={<AdminGuard><AdminSettings /></AdminGuard>} />
        <Route path="/admin/analytics"   element={<AdminGuard><AdminAnalytics /></AdminGuard>} />
        <Route path="/admin/pipeline"    element={<AdminGuard><AdminPipeline /></AdminGuard>} />

        {/* ── Fallback ─────────────────────────────────────────── */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
